<template>
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <div v-if="getLanguageChanged">{{refresh()}}</div>
        
        <v-card class="shadow-none" v-if="$store.getters.getLanguageList">     
            <div v-if="getShowHelpEvent">{{showHelp()}}</div>
            <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
            <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>
            <div v-if="needInit">{{initData()}}</div> 

            <div v-if="myContent">                
                <div v-html="myContent.content"></div>

                <div v-for="(item,index) in myList" :key="index"> 
                    <drop @drop="handleDrop" >                       
                        <drag class="drag" :transfer-data="{ index: index }" >
                            <div :class="getMyStyle(item.type)" v-if="status == 0" v-html="item.content" :id="index"></div>
                        </drag>    
                                         
                        <div v-if="status == 1" :class="getMyStyle(myResult[index].type)">
                            <span v-html="myResult[index].content" :id="index" ></span>
                        </div>

                        <div v-if="status == 2" :class="getMyStyle(item.type)">
                            <v-icon v-if="(myList[index].content == myResult[index].content)"  v-bind:style="check_ok" >check_circle</v-icon>  
                            <v-icon v-if="(myList[index].content != myResult[index].content)"  v-bind:style="check_error">error</v-icon>  
                            <span  v-html="item.content" :id="index"></span>
                        </div>
                    </drop>
                </div>
            </div>

        </v-card>

        <v-card class="shadow-none" v-if="showMyHelp">
            <div v-html="myContent.help">
            </div>
            <v-btn @click="showMyHelp = false">Hide Help</v-btn>
        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
// import { closeSync } from 'fs';
import { Drag, Drop } from 'vue-drag-drop';

export default {   
    data() {
        return {
                myContent:  {
                    content: 'loading...',
                    help: 'loading...',
                    answer_list : [{
                        answer : 'loading...',
                        feedback: 'loading...'
                    }]
                },
                feedback: null,
                showMyHelp: false,
                needInit : false,
                styleObject: {
                    color: 'black',
                },
                myList: [],
                check_ok : {
                    color: "green"                    
                },
                check_error : {
                    color: "red"
                },
                correct_answer : {
                    "text-align":"center"
                },
                myResult: [],
                status: 0 // 0 no, 1 - show, 2 - check

        }
    },
    components :{
        Drag,
        Drop
    },

    computed: 
        mapGetters([
                    'getShowHelpEvent',
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getLanguageList',
                    'getLanguagePrimary',
                    'getLanguageChanged'
                    ])
    ,    
    props: { 
        dcontent: Object
    },
    methods: {
        handleDrop(data, event) {
            // target
            let target_index = event.target.id
            let source_index = data.index
            if (target_index == '') return 
            const insert = this.myList[source_index]
            this.myList.splice(target_index,0,insert)
            if (target_index < source_index) {
                this.myList.splice(source_index+1,1)
            } else {
                this.myList.splice(source_index,1)
            }
        },
        readData(tag,result) {
            let start = result.indexOf('<'+tag+'>')
            let end = result.indexOf('</'+tag+'>')
            if (tag == 'p') {
                this.myList.push({
                                    type: 'p',
                                    content:  result.substring(start + 3, end)
                                })                            
                return result.substring(0,start) + result.substring(end + 4)  
            } else { // pre
                var lineres = result.substring(start + 5, end)
                var a = 0
                while (lineres.indexOf('\n') > -1) {
                    a = lineres.indexOf('\n')
                    this.myList.push({
                                        type: 'pre',
                                        content:  lineres.substring(0, a)
                                    })                            
                    lineres = lineres.substring(a+1)
                }
                if (lineres.length > 0) {
                    this.myList.push({
                                        type: 'pre',
                                        content:  lineres
                                    })                            
                }
                return result.substring(0,start) + result.substring(end + 6)  
            }
            
        },
        prepareLines() {
            var result = this.myContent.code
            this.myList = []
            let str = ' class="ql-syntax" spellcheck="false"'
            while (result.indexOf(str)> -1) {
              result = result.substring(0, result.indexOf(str)) + result.substring(result.indexOf(str) + str.length)
            }

            while (result.indexOf('<p>') > -1 || result.indexOf('<pre') > -1 ) { 
                if ((result.indexOf('<pre') >-1)  && (result.indexOf('<p>') >-1)) {
                       if (result.indexOf('<pre') > result.indexOf('<p>')) {
                            result = this.readData('p',result)
                       } else {
                            result = this.readData('pre',result)
                       }
                } else {
                    if (result.indexOf('<pre') > -1) {
                            result = this.readData('pre',result)
                    } else {
                            result = this.readData('p',result)
                    }    
                }
            }      

            if (result.length>0) this.myList.push({
                    type:'c',
                    content: result
            })
            
        },
        initData() {            
            this.needInit = false         
            this.status = 0
            this.$store.commit('setFeedback', null)   
            this.myContent = JSON.parse(this.dcontent.data.content)            
            
            this.prepareLines(this.myContent)
            this.myResult = this.myList.slice(0)

            // shuffle
            for(let i=0; i < this.myList.length; i++) {
                const rand = Math.floor(Math.random() * this.myList.length);
                [this.myList[i], this.myList[rand]] = [this.myList[rand], this.myList[i]];
            }                        

        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent', false)
            // compare with myResult
            this.status = 2
        },
        showAnswer() { 
            this.$store.commit('setShowAnswerEvent', false)
            this.status = 1
        },
        getStyle() {            
            if (this.status == 0) return { "color":"black"}            
            if (this.status == 1) return { "color":"green"}
        },
        myCompare(a,b) {
            if (a == b) return true
            if (this.ignoreSpaces) {
                a = a.replace(/\s/g, '')
                b = b.replace(/\s/g, '')
                if (a == b) return true
            }                
            if (this.aqSome) {
                while (a.indexOf('"') > -1) a = a.replace('"','\'')
                while (b.indexOf('"') > -1) b = b.replace('"','\'')
            }
            if (a == b) return true
            return false
        },
        showHelp() {
            this.$store.commit('setShowHelpEvent', false)
            this.showMyHelp = true
        },
        refresh() {
            this.$store.commit('setLanguageChanged',false)
            this.initData()
        },
        getMyStyle(type) {
            if (type == 'p') return 'myParagraph'
            else return 'myCode'
        }
    },
    mounted() {
        this.needInit = true
    }
}
</script>

<style>
.myCode {
	width: 100%;
	padding: 3px;
	margin: 5px;
	overflow: auto;
	overflow-y: hidden;
	font-size: 14px;
	line-height: 16px;
	background: #c7c1c156;
	border: 1px solid #777;
    font-family:'Courier New', Courier, monospace; 
}
.myParagraph {
	width: 100%;
	padding: 3px;
	margin: 5px;
	overflow: auto;
	overflow-y: hidden;
	font-size: 14px;
	line-height: 16px;
	border: 1px solid #777;
}

</style>